(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'kotlinx-html'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'kotlinx-html'.");
    }
    root['kotlinx-html'] = factory(typeof this['kotlinx-html'] === 'undefined' ? {} : this['kotlinx-html'], this['kotlin-kotlin-stdlib']);
  }
}(globalThis, function (_, kotlin_kotlin) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var protoOf = kotlin_kotlin.$_$.hb;
  var initMetadataForInterface = kotlin_kotlin.$_$.ka;
  var getProgressionLastElement = kotlin_kotlin.$_$.m9;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.u;
  var Unit_instance = kotlin_kotlin.$_$.d5;
  var setOf = kotlin_kotlin.$_$.c8;
  var listOf = kotlin_kotlin.$_$.p7;
  var THROW_CCE = kotlin_kotlin.$_$.oe;
  var getStringHashCode = kotlin_kotlin.$_$.fa;
  var KtMap = kotlin_kotlin.$_$.o5;
  var Entry = kotlin_kotlin.$_$.n5;
  var initMetadataForClass = kotlin_kotlin.$_$.ha;
  var VOID = kotlin_kotlin.$_$.g;
  var emptyMap = kotlin_kotlin.$_$.t6;
  var initMetadataForObject = kotlin_kotlin.$_$.ma;
  var joinToString = kotlin_kotlin.$_$.i7;
  var KtSet = kotlin_kotlin.$_$.s5;
  var isInterface = kotlin_kotlin.$_$.va;
  var LinkedHashMap_init_$Create$_0 = kotlin_kotlin.$_$.v;
  var KtMutableMap = kotlin_kotlin.$_$.q5;
  var Enum = kotlin_kotlin.$_$.ee;
  var mapCapacity = kotlin_kotlin.$_$.r7;
  var coerceAtLeast = kotlin_kotlin.$_$.ob;
  var LinkedHashMap_init_$Create$_1 = kotlin_kotlin.$_$.t;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.l;
  var ensureNotNull = kotlin_kotlin.$_$.ef;
  var last = kotlin_kotlin.$_$.o7;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.u1;
  var get_lastIndex = kotlin_kotlin.$_$.l7;
  var toString = kotlin_kotlin.$_$.lb;
  //endregion
  //region block: pre-declaration
  initMetadataForInterface(AttributeEnum, 'AttributeEnum');
  function text(s) {
    this.n2i().s2i(s);
  }
  initMetadataForInterface(Tag, 'Tag');
  initMetadataForClass(SingletonStringMap, 'SingletonStringMap', VOID, VOID, [KtMap, Entry]);
  initMetadataForClass(Attribute, 'Attribute');
  initMetadataForClass(StringAttribute, 'StringAttribute', StringAttribute, Attribute);
  initMetadataForClass(StringSetAttribute, 'StringSetAttribute', StringSetAttribute, Attribute);
  initMetadataForClass(BooleanAttribute, 'BooleanAttribute', BooleanAttribute, Attribute);
  initMetadataForClass(TickerAttribute, 'TickerAttribute', TickerAttribute, Attribute);
  initMetadataForClass(EnumAttribute, 'EnumAttribute', VOID, Attribute);
  initMetadataForObject(StringEncoder, 'StringEncoder');
  initMetadataForObject(StringSetEncoder, 'StringSetEncoder');
  initMetadataForClass(BooleanEncoder, 'BooleanEncoder', BooleanEncoder);
  initMetadataForObject(TickerEncoder, 'TickerEncoder');
  initMetadataForClass(EnumEncoder, 'EnumEncoder');
  initMetadataForClass(DelegatingMap, 'DelegatingMap', VOID, VOID, [KtMutableMap]);
  initMetadataForClass(ButtonFormEncType, 'ButtonFormEncType', VOID, Enum, [Enum, AttributeEnum]);
  initMetadataForClass(ButtonFormMethod, 'ButtonFormMethod', VOID, Enum, [Enum, AttributeEnum]);
  initMetadataForClass(ButtonType, 'ButtonType', VOID, Enum, [Enum, AttributeEnum]);
  initMetadataForClass(CommandType, 'CommandType', VOID, Enum, [Enum, AttributeEnum]);
  initMetadataForClass(Dir, 'Dir', VOID, Enum, [Enum, AttributeEnum]);
  initMetadataForClass(Draggable, 'Draggable', VOID, Enum, [Enum, AttributeEnum]);
  initMetadataForClass(FormEncType, 'FormEncType', VOID, Enum, [Enum, AttributeEnum]);
  initMetadataForClass(FormMethod, 'FormMethod', VOID, Enum, [Enum, AttributeEnum]);
  initMetadataForClass(IframeSandbox, 'IframeSandbox', VOID, Enum, [Enum, AttributeEnum]);
  initMetadataForClass(ImgLoading, 'ImgLoading', VOID, Enum, [Enum, AttributeEnum]);
  initMetadataForClass(InputFormEncType, 'InputFormEncType', VOID, Enum, [Enum, AttributeEnum]);
  initMetadataForClass(InputFormMethod, 'InputFormMethod', VOID, Enum, [Enum, AttributeEnum]);
  initMetadataForClass(InputType, 'InputType', VOID, Enum, [Enum, AttributeEnum]);
  initMetadataForClass(KeyGenKeyType, 'KeyGenKeyType', VOID, Enum, [Enum, AttributeEnum]);
  initMetadataForClass(RunAt, 'RunAt', VOID, Enum, [Enum, AttributeEnum]);
  initMetadataForClass(ScriptCrossorigin, 'ScriptCrossorigin', VOID, Enum, [Enum, AttributeEnum]);
  initMetadataForClass(TextAreaWrap, 'TextAreaWrap', VOID, Enum, [Enum, AttributeEnum]);
  initMetadataForClass(ThScope, 'ThScope', VOID, Enum, [Enum, AttributeEnum]);
  initMetadataForClass(AreaShape, 'AreaShape', VOID, Enum, [Enum, AttributeEnum]);
  initMetadataForClass(HTMLTag, 'HTMLTag', VOID, VOID, [Tag]);
  initMetadataForClass(A, 'A', VOID, HTMLTag, [HTMLTag, Tag]);
  initMetadataForClass(BUTTON, 'BUTTON', VOID, HTMLTag, [HTMLTag, Tag]);
  initMetadataForClass(DIV, 'DIV', VOID, HTMLTag, [HTMLTag, Tag]);
  initMetadataForClass(SCRIPT, 'SCRIPT', VOID, HTMLTag, [HTMLTag, Tag]);
  initMetadataForClass(JSDOMBuilder, 'JSDOMBuilder');
  //endregion
  function get_emptyMap() {
    _init_properties_api_kt__c2p01k();
    return emptyMap_0;
  }
  var emptyMap_0;
  function AttributeEnum() {
  }
  function Tag() {
  }
  function attributesMapOf(key, value) {
    _init_properties_api_kt__c2p01k();
    return value == null ? get_emptyMap() : singletonMapOf(key, value);
  }
  function attributesMapOf_0(pairs) {
    _init_properties_api_kt__c2p01k();
    var result = null;
    var nestedLast = pairs.length - 1 | 0;
    var inductionVariable = 0;
    var last = getProgressionLastElement(0, nestedLast, 2);
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 2 | 0;
        var k = pairs[i];
        var v = pairs[i + 1 | 0];
        if (!(k == null) && !(v == null)) {
          if (result == null) {
            // Inline function 'kotlin.collections.linkedMapOf' call
            result = LinkedHashMap_init_$Create$();
          }
          result.b2(k, v);
        }
      }
       while (!(i === last));
    var tmp1_elvis_lhs = result;
    return tmp1_elvis_lhs == null ? get_emptyMap() : tmp1_elvis_lhs;
  }
  function singletonMapOf(key, value) {
    _init_properties_api_kt__c2p01k();
    return new SingletonStringMap(key, value);
  }
  function SingletonStringMap(key, value) {
    this.t2i_1 = key;
    this.u2i_1 = value;
  }
  protoOf(SingletonStringMap).u = function () {
    return this.t2i_1;
  };
  protoOf(SingletonStringMap).v = function () {
    return this.u2i_1;
  };
  protoOf(SingletonStringMap).t = function () {
    return setOf(this);
  };
  protoOf(SingletonStringMap).z1 = function () {
    return setOf(this.t2i_1);
  };
  protoOf(SingletonStringMap).j = function () {
    return 1;
  };
  protoOf(SingletonStringMap).a2 = function () {
    return listOf(this.u2i_1);
  };
  protoOf(SingletonStringMap).v2i = function (key) {
    return key === this.t2i_1;
  };
  protoOf(SingletonStringMap).w1 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return false;
    return this.v2i((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  protoOf(SingletonStringMap).w2i = function (key) {
    return key === this.t2i_1 ? this.u2i_1 : null;
  };
  protoOf(SingletonStringMap).y1 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.w2i((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  protoOf(SingletonStringMap).o = function () {
    return false;
  };
  protoOf(SingletonStringMap).toString = function () {
    return 'SingletonStringMap(key=' + this.t2i_1 + ', value=' + this.u2i_1 + ')';
  };
  protoOf(SingletonStringMap).hashCode = function () {
    var result = getStringHashCode(this.t2i_1);
    result = imul(result, 31) + getStringHashCode(this.u2i_1) | 0;
    return result;
  };
  protoOf(SingletonStringMap).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SingletonStringMap))
      return false;
    var tmp0_other_with_cast = other instanceof SingletonStringMap ? other : THROW_CCE();
    if (!(this.t2i_1 === tmp0_other_with_cast.t2i_1))
      return false;
    if (!(this.u2i_1 === tmp0_other_with_cast.u2i_1))
      return false;
    return true;
  };
  var properties_initialized_api_kt_zfwuc6;
  function _init_properties_api_kt__c2p01k() {
    if (!properties_initialized_api_kt_zfwuc6) {
      properties_initialized_api_kt_zfwuc6 = true;
      emptyMap_0 = emptyMap();
    }
  }
  function Attribute(encoder) {
    this.x2i_1 = encoder;
  }
  protoOf(Attribute).y2i = function (thisRef, attributeName, value) {
    thisRef.p2i().b2(attributeName, this.x2i_1.z2i(attributeName, value));
  };
  function StringAttribute() {
    Attribute.call(this, StringEncoder_instance);
  }
  function StringSetAttribute() {
    Attribute.call(this, StringSetEncoder_instance);
  }
  function BooleanAttribute(trueValue, falseValue) {
    trueValue = trueValue === VOID ? 'true' : trueValue;
    falseValue = falseValue === VOID ? 'false' : falseValue;
    Attribute.call(this, new BooleanEncoder(trueValue, falseValue));
  }
  function TickerAttribute() {
    Attribute.call(this, TickerEncoder_instance);
  }
  protoOf(TickerAttribute).b2j = function (thisRef, attributeName, value) {
    if (value) {
      thisRef.p2i().b2(attributeName, attributeName);
    } else {
      thisRef.p2i().c2(attributeName);
    }
  };
  protoOf(TickerAttribute).y2i = function (thisRef, attributeName, value) {
    return this.b2j(thisRef, attributeName, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
  };
  function EnumAttribute(values) {
    Attribute.call(this, new EnumEncoder(values));
    this.d2j_1 = values;
  }
  function StringEncoder() {
  }
  protoOf(StringEncoder).e2j = function (attributeName, value) {
    return value;
  };
  protoOf(StringEncoder).z2i = function (attributeName, value) {
    return this.e2j(attributeName, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
  };
  var StringEncoder_instance;
  function StringEncoder_getInstance() {
    return StringEncoder_instance;
  }
  function StringSetEncoder() {
  }
  protoOf(StringSetEncoder).f2j = function (attributeName, value) {
    return joinToString(value, ' ');
  };
  protoOf(StringSetEncoder).z2i = function (attributeName, value) {
    return this.f2j(attributeName, (!(value == null) ? isInterface(value, KtSet) : false) ? value : THROW_CCE());
  };
  var StringSetEncoder_instance;
  function StringSetEncoder_getInstance() {
    return StringSetEncoder_instance;
  }
  function BooleanEncoder(trueValue, falseValue) {
    trueValue = trueValue === VOID ? 'true' : trueValue;
    falseValue = falseValue === VOID ? 'false' : falseValue;
    this.g2j_1 = trueValue;
    this.h2j_1 = falseValue;
  }
  protoOf(BooleanEncoder).i2j = function (attributeName, value) {
    return value ? this.g2j_1 : this.h2j_1;
  };
  protoOf(BooleanEncoder).z2i = function (attributeName, value) {
    return this.i2j(attributeName, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
  };
  function TickerEncoder() {
  }
  protoOf(TickerEncoder).i2j = function (attributeName, value) {
    return tickerEncode(value, attributeName);
  };
  protoOf(TickerEncoder).z2i = function (attributeName, value) {
    return this.i2j(attributeName, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
  };
  var TickerEncoder_instance;
  function TickerEncoder_getInstance() {
    return TickerEncoder_instance;
  }
  function EnumEncoder(valuesMap) {
    this.j2j_1 = valuesMap;
  }
  protoOf(EnumEncoder).k2j = function (attributeName, value) {
    return value.l2i();
  };
  protoOf(EnumEncoder).z2i = function (attributeName, value) {
    return this.k2j(attributeName, (!(value == null) ? isInterface(value, AttributeEnum) : false) ? value : THROW_CCE());
  };
  function tickerEncode(_this__u8e3s4, attributeName) {
    return _this__u8e3s4 ? attributeName : '';
  }
  function enumEncode(_this__u8e3s4) {
    return _this__u8e3s4.l2i();
  }
  function switchToMutable($this) {
    var tmp;
    if ($this.o2j_1) {
      tmp = $this.n2j_1;
    } else {
      $this.o2j_1 = true;
      $this.n2j_1 = LinkedHashMap_init_$Create$_0($this.n2j_1);
      tmp = $this.n2j_1;
    }
    var tmp_0 = tmp;
    return isInterface(tmp_0, KtMutableMap) ? tmp_0 : THROW_CCE();
  }
  function DelegatingMap(initialValues, tag, consumer) {
    this.l2j_1 = tag;
    this.m2j_1 = consumer;
    this.n2j_1 = initialValues;
    this.o2j_1 = false;
  }
  protoOf(DelegatingMap).j = function () {
    return this.n2j_1.j();
  };
  protoOf(DelegatingMap).o = function () {
    return this.n2j_1.o();
  };
  protoOf(DelegatingMap).v2i = function (key) {
    return this.n2j_1.w1(key);
  };
  protoOf(DelegatingMap).w1 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return false;
    return this.v2i((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  protoOf(DelegatingMap).w2i = function (key) {
    return this.n2j_1.y1(key);
  };
  protoOf(DelegatingMap).y1 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.w2i((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  protoOf(DelegatingMap).p2j = function (key, value) {
    var mutable = switchToMutable(this);
    var old = mutable.b2(key, value);
    if (!(old === value)) {
      this.m2j_1().q2j(this.l2j_1, key, value);
    }
    return old;
  };
  protoOf(DelegatingMap).b2 = function (key, value) {
    var tmp = (!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE();
    return this.p2j(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
  };
  protoOf(DelegatingMap).r2j = function (key) {
    var mutable = switchToMutable(this);
    var tmp0_safe_receiver = mutable.c2(key);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.html.impl.DelegatingMap.remove.<anonymous>' call
      this.m2j_1().q2j(this.l2j_1, key, null);
      tmp = tmp0_safe_receiver;
    }
    return tmp;
  };
  protoOf(DelegatingMap).c2 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.r2j((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  protoOf(DelegatingMap).s2j = function (from) {
    if (from.o())
      return Unit_instance;
    var consumer = this.m2j_1();
    var mutable = switchToMutable(this);
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = from.t().g();
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      // Inline function 'kotlinx.html.impl.DelegatingMap.putAll.<anonymous>' call
      if (!(mutable.b2(element.u(), element.v()) === element.v())) {
        consumer.q2j(this.l2j_1, element.u(), element.v());
      }
    }
  };
  protoOf(DelegatingMap).d2 = function (from) {
    return this.s2j(from);
  };
  protoOf(DelegatingMap).s1 = function () {
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = this.n2j_1.t().g();
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      // Inline function 'kotlinx.html.impl.DelegatingMap.clear.<anonymous>' call
      this.m2j_1().q2j(this.l2j_1, element.u(), null);
    }
    this.n2j_1 = emptyMap();
    this.o2j_1 = false;
  };
  protoOf(DelegatingMap).t2j = function () {
    return this.n2j_1.t();
  };
  protoOf(DelegatingMap).z1 = function () {
    return switchToMutable(this).z1();
  };
  protoOf(DelegatingMap).a2 = function () {
    return switchToMutable(this).a2();
  };
  protoOf(DelegatingMap).t = function () {
    return switchToMutable(this).t();
  };
  function set_classes(_this__u8e3s4, newValue) {
    get_attributeSetStringStringSet().y2i(_this__u8e3s4, 'class', newValue);
  }
  var attributeStringString;
  function get_attributeSetStringStringSet() {
    _init_properties_gen_attributes_kt__jy8yj0();
    return attributeSetStringStringSet;
  }
  var attributeSetStringStringSet;
  var attributeBooleanBoolean;
  var attributeBooleanBooleanOnOff;
  var attributeBooleanTicker;
  var attributeButtonFormEncTypeEnumButtonFormEncTypeValues;
  var attributeButtonFormMethodEnumButtonFormMethodValues;
  var attributeButtonTypeEnumButtonTypeValues;
  var attributeCommandTypeEnumCommandTypeValues;
  var attributeDirEnumDirValues;
  var attributeDraggableEnumDraggableValues;
  var attributeFormEncTypeEnumFormEncTypeValues;
  var attributeFormMethodEnumFormMethodValues;
  var attributeIframeSandboxEnumIframeSandboxValues;
  var attributeImgLoadingEnumImgLoadingValues;
  var attributeInputFormEncTypeEnumInputFormEncTypeValues;
  var attributeInputFormMethodEnumInputFormMethodValues;
  var attributeInputTypeEnumInputTypeValues;
  var attributeKeyGenKeyTypeEnumKeyGenKeyTypeValues;
  var attributeRunAtEnumRunAtValues;
  var attributeScriptCrossoriginEnumScriptCrossoriginValues;
  var attributeTextAreaWrapEnumTextAreaWrapValues;
  var attributeThScopeEnumThScopeValues;
  var properties_initialized_gen_attributes_kt_jgv7sa;
  function _init_properties_gen_attributes_kt__jy8yj0() {
    if (!properties_initialized_gen_attributes_kt_jgv7sa) {
      properties_initialized_gen_attributes_kt_jgv7sa = true;
      attributeStringString = new StringAttribute();
      attributeSetStringStringSet = new StringSetAttribute();
      attributeBooleanBoolean = new BooleanAttribute();
      attributeBooleanBooleanOnOff = new BooleanAttribute('on', 'off');
      attributeBooleanTicker = new TickerAttribute();
      attributeButtonFormEncTypeEnumButtonFormEncTypeValues = new EnumAttribute(get_buttonFormEncTypeValues());
      attributeButtonFormMethodEnumButtonFormMethodValues = new EnumAttribute(get_buttonFormMethodValues());
      attributeButtonTypeEnumButtonTypeValues = new EnumAttribute(get_buttonTypeValues());
      attributeCommandTypeEnumCommandTypeValues = new EnumAttribute(get_commandTypeValues());
      attributeDirEnumDirValues = new EnumAttribute(get_dirValues());
      attributeDraggableEnumDraggableValues = new EnumAttribute(get_draggableValues());
      attributeFormEncTypeEnumFormEncTypeValues = new EnumAttribute(get_formEncTypeValues());
      attributeFormMethodEnumFormMethodValues = new EnumAttribute(get_formMethodValues());
      attributeIframeSandboxEnumIframeSandboxValues = new EnumAttribute(get_iframeSandboxValues());
      attributeImgLoadingEnumImgLoadingValues = new EnumAttribute(get_imgLoadingValues());
      attributeInputFormEncTypeEnumInputFormEncTypeValues = new EnumAttribute(get_inputFormEncTypeValues());
      attributeInputFormMethodEnumInputFormMethodValues = new EnumAttribute(get_inputFormMethodValues());
      attributeInputTypeEnumInputTypeValues = new EnumAttribute(get_inputTypeValues());
      attributeKeyGenKeyTypeEnumKeyGenKeyTypeValues = new EnumAttribute(get_keyGenKeyTypeValues());
      attributeRunAtEnumRunAtValues = new EnumAttribute(get_runAtValues());
      attributeScriptCrossoriginEnumScriptCrossoriginValues = new EnumAttribute(get_scriptCrossoriginValues());
      attributeTextAreaWrapEnumTextAreaWrapValues = new EnumAttribute(get_textAreaWrapValues());
      attributeThScopeEnumThScopeValues = new EnumAttribute(get_thScopeValues());
    }
  }
  function get_dirValues() {
    _init_properties_gen_enums_kt__jr8w3n();
    return dirValues;
  }
  var dirValues;
  function get_draggableValues() {
    _init_properties_gen_enums_kt__jr8w3n();
    return draggableValues;
  }
  var draggableValues;
  function get_runAtValues() {
    _init_properties_gen_enums_kt__jr8w3n();
    return runAtValues;
  }
  var runAtValues;
  var areaShapeValues;
  function get_buttonFormEncTypeValues() {
    _init_properties_gen_enums_kt__jr8w3n();
    return buttonFormEncTypeValues;
  }
  var buttonFormEncTypeValues;
  function get_buttonFormMethodValues() {
    _init_properties_gen_enums_kt__jr8w3n();
    return buttonFormMethodValues;
  }
  var buttonFormMethodValues;
  function get_buttonTypeValues() {
    _init_properties_gen_enums_kt__jr8w3n();
    return buttonTypeValues;
  }
  var buttonTypeValues;
  function get_commandTypeValues() {
    _init_properties_gen_enums_kt__jr8w3n();
    return commandTypeValues;
  }
  var commandTypeValues;
  function get_formEncTypeValues() {
    _init_properties_gen_enums_kt__jr8w3n();
    return formEncTypeValues;
  }
  var formEncTypeValues;
  function get_formMethodValues() {
    _init_properties_gen_enums_kt__jr8w3n();
    return formMethodValues;
  }
  var formMethodValues;
  function get_iframeSandboxValues() {
    _init_properties_gen_enums_kt__jr8w3n();
    return iframeSandboxValues;
  }
  var iframeSandboxValues;
  function get_imgLoadingValues() {
    _init_properties_gen_enums_kt__jr8w3n();
    return imgLoadingValues;
  }
  var imgLoadingValues;
  function get_inputTypeValues() {
    _init_properties_gen_enums_kt__jr8w3n();
    return inputTypeValues;
  }
  var inputTypeValues;
  function get_inputFormEncTypeValues() {
    _init_properties_gen_enums_kt__jr8w3n();
    return inputFormEncTypeValues;
  }
  var inputFormEncTypeValues;
  function get_inputFormMethodValues() {
    _init_properties_gen_enums_kt__jr8w3n();
    return inputFormMethodValues;
  }
  var inputFormMethodValues;
  function get_keyGenKeyTypeValues() {
    _init_properties_gen_enums_kt__jr8w3n();
    return keyGenKeyTypeValues;
  }
  var keyGenKeyTypeValues;
  function get_scriptCrossoriginValues() {
    _init_properties_gen_enums_kt__jr8w3n();
    return scriptCrossoriginValues;
  }
  var scriptCrossoriginValues;
  function get_textAreaWrapValues() {
    _init_properties_gen_enums_kt__jr8w3n();
    return textAreaWrapValues;
  }
  var textAreaWrapValues;
  function get_thScopeValues() {
    _init_properties_gen_enums_kt__jr8w3n();
    return thScopeValues;
  }
  var thScopeValues;
  var ButtonFormEncType_multipartFormData_instance;
  var ButtonFormEncType_applicationXWwwFormUrlEncoded_instance;
  var ButtonFormEncType_textPlain_instance;
  function values() {
    return [ButtonFormEncType_multipartFormData_getInstance(), ButtonFormEncType_applicationXWwwFormUrlEncoded_getInstance(), ButtonFormEncType_textPlain_getInstance()];
  }
  var ButtonFormEncType_entriesInitialized;
  function ButtonFormEncType_initEntries() {
    if (ButtonFormEncType_entriesInitialized)
      return Unit_instance;
    ButtonFormEncType_entriesInitialized = true;
    ButtonFormEncType_multipartFormData_instance = new ButtonFormEncType('multipartFormData', 0, 'multipart/form-data');
    ButtonFormEncType_applicationXWwwFormUrlEncoded_instance = new ButtonFormEncType('applicationXWwwFormUrlEncoded', 1, 'application/x-www-form-urlencoded');
    ButtonFormEncType_textPlain_instance = new ButtonFormEncType('textPlain', 2, 'text/plain');
  }
  function ButtonFormEncType(name, ordinal, realValue) {
    Enum.call(this, name, ordinal);
    this.w2j_1 = realValue;
  }
  protoOf(ButtonFormEncType).l2i = function () {
    return this.w2j_1;
  };
  var ButtonFormMethod_get_instance;
  var ButtonFormMethod_post_instance;
  var ButtonFormMethod_put_instance;
  var ButtonFormMethod_delete_instance;
  var ButtonFormMethod_patch_instance;
  function values_0() {
    return [ButtonFormMethod_get_getInstance(), ButtonFormMethod_post_getInstance(), ButtonFormMethod_put_getInstance(), ButtonFormMethod_delete_getInstance(), ButtonFormMethod_patch_getInstance()];
  }
  var ButtonFormMethod_entriesInitialized;
  function ButtonFormMethod_initEntries() {
    if (ButtonFormMethod_entriesInitialized)
      return Unit_instance;
    ButtonFormMethod_entriesInitialized = true;
    ButtonFormMethod_get_instance = new ButtonFormMethod('get', 0, 'get');
    ButtonFormMethod_post_instance = new ButtonFormMethod('post', 1, 'post');
    ButtonFormMethod_put_instance = new ButtonFormMethod('put', 2, 'put');
    ButtonFormMethod_delete_instance = new ButtonFormMethod('delete', 3, 'delete');
    ButtonFormMethod_patch_instance = new ButtonFormMethod('patch', 4, 'patch');
  }
  function ButtonFormMethod(name, ordinal, realValue) {
    Enum.call(this, name, ordinal);
    this.z2j_1 = realValue;
  }
  protoOf(ButtonFormMethod).l2i = function () {
    return this.z2j_1;
  };
  var ButtonType_button_instance;
  var ButtonType_reset_instance;
  var ButtonType_submit_instance;
  function values_1() {
    return [ButtonType_button_getInstance(), ButtonType_reset_getInstance(), ButtonType_submit_getInstance()];
  }
  var ButtonType_entriesInitialized;
  function ButtonType_initEntries() {
    if (ButtonType_entriesInitialized)
      return Unit_instance;
    ButtonType_entriesInitialized = true;
    ButtonType_button_instance = new ButtonType('button', 0, 'button');
    ButtonType_reset_instance = new ButtonType('reset', 1, 'reset');
    ButtonType_submit_instance = new ButtonType('submit', 2, 'submit');
  }
  function ButtonType(name, ordinal, realValue) {
    Enum.call(this, name, ordinal);
    this.c2k_1 = realValue;
  }
  protoOf(ButtonType).l2i = function () {
    return this.c2k_1;
  };
  var CommandType_command_instance;
  var CommandType_checkBox_instance;
  var CommandType_radio_instance;
  function values_2() {
    return [CommandType_command_getInstance(), CommandType_checkBox_getInstance(), CommandType_radio_getInstance()];
  }
  var CommandType_entriesInitialized;
  function CommandType_initEntries() {
    if (CommandType_entriesInitialized)
      return Unit_instance;
    CommandType_entriesInitialized = true;
    CommandType_command_instance = new CommandType('command', 0, 'command');
    CommandType_checkBox_instance = new CommandType('checkBox', 1, 'checkbox');
    CommandType_radio_instance = new CommandType('radio', 2, 'radio');
  }
  function CommandType(name, ordinal, realValue) {
    Enum.call(this, name, ordinal);
    this.f2k_1 = realValue;
  }
  protoOf(CommandType).l2i = function () {
    return this.f2k_1;
  };
  var Dir_ltr_instance;
  var Dir_rtl_instance;
  function values_3() {
    return [Dir_ltr_getInstance(), Dir_rtl_getInstance()];
  }
  var Dir_entriesInitialized;
  function Dir_initEntries() {
    if (Dir_entriesInitialized)
      return Unit_instance;
    Dir_entriesInitialized = true;
    Dir_ltr_instance = new Dir('ltr', 0, 'ltr');
    Dir_rtl_instance = new Dir('rtl', 1, 'rtl');
  }
  function Dir(name, ordinal, realValue) {
    Enum.call(this, name, ordinal);
    this.i2k_1 = realValue;
  }
  protoOf(Dir).l2i = function () {
    return this.i2k_1;
  };
  var Draggable_htmlTrue_instance;
  var Draggable_htmlFalse_instance;
  var Draggable_auto_instance;
  function values_4() {
    return [Draggable_htmlTrue_getInstance(), Draggable_htmlFalse_getInstance(), Draggable_auto_getInstance()];
  }
  var Draggable_entriesInitialized;
  function Draggable_initEntries() {
    if (Draggable_entriesInitialized)
      return Unit_instance;
    Draggable_entriesInitialized = true;
    Draggable_htmlTrue_instance = new Draggable('htmlTrue', 0, 'true');
    Draggable_htmlFalse_instance = new Draggable('htmlFalse', 1, 'false');
    Draggable_auto_instance = new Draggable('auto', 2, 'auto');
  }
  function Draggable(name, ordinal, realValue) {
    Enum.call(this, name, ordinal);
    this.l2k_1 = realValue;
  }
  protoOf(Draggable).l2i = function () {
    return this.l2k_1;
  };
  var FormEncType_multipartFormData_instance;
  var FormEncType_applicationXWwwFormUrlEncoded_instance;
  var FormEncType_textPlain_instance;
  function values_5() {
    return [FormEncType_multipartFormData_getInstance(), FormEncType_applicationXWwwFormUrlEncoded_getInstance(), FormEncType_textPlain_getInstance()];
  }
  var FormEncType_entriesInitialized;
  function FormEncType_initEntries() {
    if (FormEncType_entriesInitialized)
      return Unit_instance;
    FormEncType_entriesInitialized = true;
    FormEncType_multipartFormData_instance = new FormEncType('multipartFormData', 0, 'multipart/form-data');
    FormEncType_applicationXWwwFormUrlEncoded_instance = new FormEncType('applicationXWwwFormUrlEncoded', 1, 'application/x-www-form-urlencoded');
    FormEncType_textPlain_instance = new FormEncType('textPlain', 2, 'text/plain');
  }
  function FormEncType(name, ordinal, realValue) {
    Enum.call(this, name, ordinal);
    this.o2k_1 = realValue;
  }
  protoOf(FormEncType).l2i = function () {
    return this.o2k_1;
  };
  var FormMethod_get_instance;
  var FormMethod_post_instance;
  var FormMethod_put_instance;
  var FormMethod_delete_instance;
  var FormMethod_patch_instance;
  function values_6() {
    return [FormMethod_get_getInstance(), FormMethod_post_getInstance(), FormMethod_put_getInstance(), FormMethod_delete_getInstance(), FormMethod_patch_getInstance()];
  }
  var FormMethod_entriesInitialized;
  function FormMethod_initEntries() {
    if (FormMethod_entriesInitialized)
      return Unit_instance;
    FormMethod_entriesInitialized = true;
    FormMethod_get_instance = new FormMethod('get', 0, 'get');
    FormMethod_post_instance = new FormMethod('post', 1, 'post');
    FormMethod_put_instance = new FormMethod('put', 2, 'put');
    FormMethod_delete_instance = new FormMethod('delete', 3, 'delete');
    FormMethod_patch_instance = new FormMethod('patch', 4, 'patch');
  }
  function FormMethod(name, ordinal, realValue) {
    Enum.call(this, name, ordinal);
    this.r2k_1 = realValue;
  }
  protoOf(FormMethod).l2i = function () {
    return this.r2k_1;
  };
  var IframeSandbox_allowSameOrigin_instance;
  var IframeSandbox_allowFormS_instance;
  var IframeSandbox_allowScripts_instance;
  function values_7() {
    return [IframeSandbox_allowSameOrigin_getInstance(), IframeSandbox_allowFormS_getInstance(), IframeSandbox_allowScripts_getInstance()];
  }
  var IframeSandbox_entriesInitialized;
  function IframeSandbox_initEntries() {
    if (IframeSandbox_entriesInitialized)
      return Unit_instance;
    IframeSandbox_entriesInitialized = true;
    IframeSandbox_allowSameOrigin_instance = new IframeSandbox('allowSameOrigin', 0, 'allow-same-origin');
    IframeSandbox_allowFormS_instance = new IframeSandbox('allowFormS', 1, 'allow-forms');
    IframeSandbox_allowScripts_instance = new IframeSandbox('allowScripts', 2, 'allow-scripts');
  }
  function IframeSandbox(name, ordinal, realValue) {
    Enum.call(this, name, ordinal);
    this.u2k_1 = realValue;
  }
  protoOf(IframeSandbox).l2i = function () {
    return this.u2k_1;
  };
  var ImgLoading_eager_instance;
  var ImgLoading_lazy_instance;
  function values_8() {
    return [ImgLoading_eager_getInstance(), ImgLoading_lazy_getInstance()];
  }
  var ImgLoading_entriesInitialized;
  function ImgLoading_initEntries() {
    if (ImgLoading_entriesInitialized)
      return Unit_instance;
    ImgLoading_entriesInitialized = true;
    ImgLoading_eager_instance = new ImgLoading('eager', 0, 'eager');
    ImgLoading_lazy_instance = new ImgLoading('lazy', 1, 'lazy');
  }
  function ImgLoading(name, ordinal, realValue) {
    Enum.call(this, name, ordinal);
    this.x2k_1 = realValue;
  }
  protoOf(ImgLoading).l2i = function () {
    return this.x2k_1;
  };
  var InputFormEncType_multipartFormData_instance;
  var InputFormEncType_applicationXWwwFormUrlEncoded_instance;
  var InputFormEncType_textPlain_instance;
  function values_9() {
    return [InputFormEncType_multipartFormData_getInstance(), InputFormEncType_applicationXWwwFormUrlEncoded_getInstance(), InputFormEncType_textPlain_getInstance()];
  }
  var InputFormEncType_entriesInitialized;
  function InputFormEncType_initEntries() {
    if (InputFormEncType_entriesInitialized)
      return Unit_instance;
    InputFormEncType_entriesInitialized = true;
    InputFormEncType_multipartFormData_instance = new InputFormEncType('multipartFormData', 0, 'multipart/form-data');
    InputFormEncType_applicationXWwwFormUrlEncoded_instance = new InputFormEncType('applicationXWwwFormUrlEncoded', 1, 'application/x-www-form-urlencoded');
    InputFormEncType_textPlain_instance = new InputFormEncType('textPlain', 2, 'text/plain');
  }
  function InputFormEncType(name, ordinal, realValue) {
    Enum.call(this, name, ordinal);
    this.a2l_1 = realValue;
  }
  protoOf(InputFormEncType).l2i = function () {
    return this.a2l_1;
  };
  var InputFormMethod_get_instance;
  var InputFormMethod_post_instance;
  var InputFormMethod_put_instance;
  var InputFormMethod_delete_instance;
  var InputFormMethod_patch_instance;
  function values_10() {
    return [InputFormMethod_get_getInstance(), InputFormMethod_post_getInstance(), InputFormMethod_put_getInstance(), InputFormMethod_delete_getInstance(), InputFormMethod_patch_getInstance()];
  }
  var InputFormMethod_entriesInitialized;
  function InputFormMethod_initEntries() {
    if (InputFormMethod_entriesInitialized)
      return Unit_instance;
    InputFormMethod_entriesInitialized = true;
    InputFormMethod_get_instance = new InputFormMethod('get', 0, 'get');
    InputFormMethod_post_instance = new InputFormMethod('post', 1, 'post');
    InputFormMethod_put_instance = new InputFormMethod('put', 2, 'put');
    InputFormMethod_delete_instance = new InputFormMethod('delete', 3, 'delete');
    InputFormMethod_patch_instance = new InputFormMethod('patch', 4, 'patch');
  }
  function InputFormMethod(name, ordinal, realValue) {
    Enum.call(this, name, ordinal);
    this.d2l_1 = realValue;
  }
  protoOf(InputFormMethod).l2i = function () {
    return this.d2l_1;
  };
  var InputType_button_instance;
  var InputType_checkBox_instance;
  var InputType_color_instance;
  var InputType_date_instance;
  var InputType_dateTime_instance;
  var InputType_dateTimeLocal_instance;
  var InputType_email_instance;
  var InputType_file_instance;
  var InputType_hidden_instance;
  var InputType_image_instance;
  var InputType_month_instance;
  var InputType_number_instance;
  var InputType_password_instance;
  var InputType_radio_instance;
  var InputType_range_instance;
  var InputType_reset_instance;
  var InputType_search_instance;
  var InputType_submit_instance;
  var InputType_text_instance;
  var InputType_tel_instance;
  var InputType_time_instance;
  var InputType_url_instance;
  var InputType_week_instance;
  function values_11() {
    return [InputType_button_getInstance(), InputType_checkBox_getInstance(), InputType_color_getInstance(), InputType_date_getInstance(), InputType_dateTime_getInstance(), InputType_dateTimeLocal_getInstance(), InputType_email_getInstance(), InputType_file_getInstance(), InputType_hidden_getInstance(), InputType_image_getInstance(), InputType_month_getInstance(), InputType_number_getInstance(), InputType_password_getInstance(), InputType_radio_getInstance(), InputType_range_getInstance(), InputType_reset_getInstance(), InputType_search_getInstance(), InputType_submit_getInstance(), InputType_text_getInstance(), InputType_tel_getInstance(), InputType_time_getInstance(), InputType_url_getInstance(), InputType_week_getInstance()];
  }
  var InputType_entriesInitialized;
  function InputType_initEntries() {
    if (InputType_entriesInitialized)
      return Unit_instance;
    InputType_entriesInitialized = true;
    InputType_button_instance = new InputType('button', 0, 'button');
    InputType_checkBox_instance = new InputType('checkBox', 1, 'checkbox');
    InputType_color_instance = new InputType('color', 2, 'color');
    InputType_date_instance = new InputType('date', 3, 'date');
    InputType_dateTime_instance = new InputType('dateTime', 4, 'datetime');
    InputType_dateTimeLocal_instance = new InputType('dateTimeLocal', 5, 'datetime-local');
    InputType_email_instance = new InputType('email', 6, 'email');
    InputType_file_instance = new InputType('file', 7, 'file');
    InputType_hidden_instance = new InputType('hidden', 8, 'hidden');
    InputType_image_instance = new InputType('image', 9, 'image');
    InputType_month_instance = new InputType('month', 10, 'month');
    InputType_number_instance = new InputType('number', 11, 'number');
    InputType_password_instance = new InputType('password', 12, 'password');
    InputType_radio_instance = new InputType('radio', 13, 'radio');
    InputType_range_instance = new InputType('range', 14, 'range');
    InputType_reset_instance = new InputType('reset', 15, 'reset');
    InputType_search_instance = new InputType('search', 16, 'search');
    InputType_submit_instance = new InputType('submit', 17, 'submit');
    InputType_text_instance = new InputType('text', 18, 'text');
    InputType_tel_instance = new InputType('tel', 19, 'tel');
    InputType_time_instance = new InputType('time', 20, 'time');
    InputType_url_instance = new InputType('url', 21, 'url');
    InputType_week_instance = new InputType('week', 22, 'week');
  }
  function InputType(name, ordinal, realValue) {
    Enum.call(this, name, ordinal);
    this.g2l_1 = realValue;
  }
  protoOf(InputType).l2i = function () {
    return this.g2l_1;
  };
  var KeyGenKeyType_rsa_instance;
  function values_12() {
    return [KeyGenKeyType_rsa_getInstance()];
  }
  var KeyGenKeyType_entriesInitialized;
  function KeyGenKeyType_initEntries() {
    if (KeyGenKeyType_entriesInitialized)
      return Unit_instance;
    KeyGenKeyType_entriesInitialized = true;
    KeyGenKeyType_rsa_instance = new KeyGenKeyType('rsa', 0, 'rsa');
  }
  function KeyGenKeyType(name, ordinal, realValue) {
    Enum.call(this, name, ordinal);
    this.j2l_1 = realValue;
  }
  protoOf(KeyGenKeyType).l2i = function () {
    return this.j2l_1;
  };
  var RunAt_server_instance;
  function values_13() {
    return [RunAt_server_getInstance()];
  }
  var RunAt_entriesInitialized;
  function RunAt_initEntries() {
    if (RunAt_entriesInitialized)
      return Unit_instance;
    RunAt_entriesInitialized = true;
    RunAt_server_instance = new RunAt('server', 0, 'server');
  }
  function RunAt(name, ordinal, realValue) {
    Enum.call(this, name, ordinal);
    this.m2l_1 = realValue;
  }
  protoOf(RunAt).l2i = function () {
    return this.m2l_1;
  };
  var ScriptCrossorigin_anonymous_instance;
  var ScriptCrossorigin_useCredentials_instance;
  function values_14() {
    return [ScriptCrossorigin_anonymous_getInstance(), ScriptCrossorigin_useCredentials_getInstance()];
  }
  var ScriptCrossorigin_entriesInitialized;
  function ScriptCrossorigin_initEntries() {
    if (ScriptCrossorigin_entriesInitialized)
      return Unit_instance;
    ScriptCrossorigin_entriesInitialized = true;
    ScriptCrossorigin_anonymous_instance = new ScriptCrossorigin('anonymous', 0, 'anonymous');
    ScriptCrossorigin_useCredentials_instance = new ScriptCrossorigin('useCredentials', 1, 'use-credentials');
  }
  function ScriptCrossorigin(name, ordinal, realValue) {
    Enum.call(this, name, ordinal);
    this.p2l_1 = realValue;
  }
  protoOf(ScriptCrossorigin).l2i = function () {
    return this.p2l_1;
  };
  var TextAreaWrap_hard_instance;
  var TextAreaWrap_soft_instance;
  function values_15() {
    return [TextAreaWrap_hard_getInstance(), TextAreaWrap_soft_getInstance()];
  }
  var TextAreaWrap_entriesInitialized;
  function TextAreaWrap_initEntries() {
    if (TextAreaWrap_entriesInitialized)
      return Unit_instance;
    TextAreaWrap_entriesInitialized = true;
    TextAreaWrap_hard_instance = new TextAreaWrap('hard', 0, 'hard');
    TextAreaWrap_soft_instance = new TextAreaWrap('soft', 1, 'soft');
  }
  function TextAreaWrap(name, ordinal, realValue) {
    Enum.call(this, name, ordinal);
    this.s2l_1 = realValue;
  }
  protoOf(TextAreaWrap).l2i = function () {
    return this.s2l_1;
  };
  var ThScope_col_instance;
  var ThScope_colGroup_instance;
  var ThScope_row_instance;
  var ThScope_rowGroup_instance;
  function values_16() {
    return [ThScope_col_getInstance(), ThScope_colGroup_getInstance(), ThScope_row_getInstance(), ThScope_rowGroup_getInstance()];
  }
  var ThScope_entriesInitialized;
  function ThScope_initEntries() {
    if (ThScope_entriesInitialized)
      return Unit_instance;
    ThScope_entriesInitialized = true;
    ThScope_col_instance = new ThScope('col', 0, 'col');
    ThScope_colGroup_instance = new ThScope('colGroup', 1, 'colgroup');
    ThScope_row_instance = new ThScope('row', 2, 'row');
    ThScope_rowGroup_instance = new ThScope('rowGroup', 3, 'rowgroup');
  }
  function ThScope(name, ordinal, realValue) {
    Enum.call(this, name, ordinal);
    this.v2l_1 = realValue;
  }
  protoOf(ThScope).l2i = function () {
    return this.v2l_1;
  };
  var AreaShape_rect_instance;
  var AreaShape_circle_instance;
  var AreaShape_poly_instance;
  var AreaShape_default_instance;
  function values_17() {
    return [AreaShape_rect_getInstance(), AreaShape_circle_getInstance(), AreaShape_poly_getInstance(), AreaShape_default_getInstance()];
  }
  var AreaShape_entriesInitialized;
  function AreaShape_initEntries() {
    if (AreaShape_entriesInitialized)
      return Unit_instance;
    AreaShape_entriesInitialized = true;
    AreaShape_rect_instance = new AreaShape('rect', 0, 'rect');
    AreaShape_circle_instance = new AreaShape('circle', 1, 'circle');
    AreaShape_poly_instance = new AreaShape('poly', 2, 'poly');
    AreaShape_default_instance = new AreaShape('default', 3, 'default');
  }
  function AreaShape(name, ordinal, realValue) {
    Enum.call(this, name, ordinal);
    this.y2l_1 = realValue;
  }
  protoOf(AreaShape).l2i = function () {
    return this.y2l_1;
  };
  function ButtonFormEncType_multipartFormData_getInstance() {
    ButtonFormEncType_initEntries();
    return ButtonFormEncType_multipartFormData_instance;
  }
  function ButtonFormEncType_applicationXWwwFormUrlEncoded_getInstance() {
    ButtonFormEncType_initEntries();
    return ButtonFormEncType_applicationXWwwFormUrlEncoded_instance;
  }
  function ButtonFormEncType_textPlain_getInstance() {
    ButtonFormEncType_initEntries();
    return ButtonFormEncType_textPlain_instance;
  }
  function ButtonFormMethod_get_getInstance() {
    ButtonFormMethod_initEntries();
    return ButtonFormMethod_get_instance;
  }
  function ButtonFormMethod_post_getInstance() {
    ButtonFormMethod_initEntries();
    return ButtonFormMethod_post_instance;
  }
  function ButtonFormMethod_put_getInstance() {
    ButtonFormMethod_initEntries();
    return ButtonFormMethod_put_instance;
  }
  function ButtonFormMethod_delete_getInstance() {
    ButtonFormMethod_initEntries();
    return ButtonFormMethod_delete_instance;
  }
  function ButtonFormMethod_patch_getInstance() {
    ButtonFormMethod_initEntries();
    return ButtonFormMethod_patch_instance;
  }
  function ButtonType_button_getInstance() {
    ButtonType_initEntries();
    return ButtonType_button_instance;
  }
  function ButtonType_reset_getInstance() {
    ButtonType_initEntries();
    return ButtonType_reset_instance;
  }
  function ButtonType_submit_getInstance() {
    ButtonType_initEntries();
    return ButtonType_submit_instance;
  }
  function CommandType_command_getInstance() {
    CommandType_initEntries();
    return CommandType_command_instance;
  }
  function CommandType_checkBox_getInstance() {
    CommandType_initEntries();
    return CommandType_checkBox_instance;
  }
  function CommandType_radio_getInstance() {
    CommandType_initEntries();
    return CommandType_radio_instance;
  }
  function Dir_ltr_getInstance() {
    Dir_initEntries();
    return Dir_ltr_instance;
  }
  function Dir_rtl_getInstance() {
    Dir_initEntries();
    return Dir_rtl_instance;
  }
  function Draggable_htmlTrue_getInstance() {
    Draggable_initEntries();
    return Draggable_htmlTrue_instance;
  }
  function Draggable_htmlFalse_getInstance() {
    Draggable_initEntries();
    return Draggable_htmlFalse_instance;
  }
  function Draggable_auto_getInstance() {
    Draggable_initEntries();
    return Draggable_auto_instance;
  }
  function FormEncType_multipartFormData_getInstance() {
    FormEncType_initEntries();
    return FormEncType_multipartFormData_instance;
  }
  function FormEncType_applicationXWwwFormUrlEncoded_getInstance() {
    FormEncType_initEntries();
    return FormEncType_applicationXWwwFormUrlEncoded_instance;
  }
  function FormEncType_textPlain_getInstance() {
    FormEncType_initEntries();
    return FormEncType_textPlain_instance;
  }
  function FormMethod_get_getInstance() {
    FormMethod_initEntries();
    return FormMethod_get_instance;
  }
  function FormMethod_post_getInstance() {
    FormMethod_initEntries();
    return FormMethod_post_instance;
  }
  function FormMethod_put_getInstance() {
    FormMethod_initEntries();
    return FormMethod_put_instance;
  }
  function FormMethod_delete_getInstance() {
    FormMethod_initEntries();
    return FormMethod_delete_instance;
  }
  function FormMethod_patch_getInstance() {
    FormMethod_initEntries();
    return FormMethod_patch_instance;
  }
  function IframeSandbox_allowSameOrigin_getInstance() {
    IframeSandbox_initEntries();
    return IframeSandbox_allowSameOrigin_instance;
  }
  function IframeSandbox_allowFormS_getInstance() {
    IframeSandbox_initEntries();
    return IframeSandbox_allowFormS_instance;
  }
  function IframeSandbox_allowScripts_getInstance() {
    IframeSandbox_initEntries();
    return IframeSandbox_allowScripts_instance;
  }
  function ImgLoading_eager_getInstance() {
    ImgLoading_initEntries();
    return ImgLoading_eager_instance;
  }
  function ImgLoading_lazy_getInstance() {
    ImgLoading_initEntries();
    return ImgLoading_lazy_instance;
  }
  function InputFormEncType_multipartFormData_getInstance() {
    InputFormEncType_initEntries();
    return InputFormEncType_multipartFormData_instance;
  }
  function InputFormEncType_applicationXWwwFormUrlEncoded_getInstance() {
    InputFormEncType_initEntries();
    return InputFormEncType_applicationXWwwFormUrlEncoded_instance;
  }
  function InputFormEncType_textPlain_getInstance() {
    InputFormEncType_initEntries();
    return InputFormEncType_textPlain_instance;
  }
  function InputFormMethod_get_getInstance() {
    InputFormMethod_initEntries();
    return InputFormMethod_get_instance;
  }
  function InputFormMethod_post_getInstance() {
    InputFormMethod_initEntries();
    return InputFormMethod_post_instance;
  }
  function InputFormMethod_put_getInstance() {
    InputFormMethod_initEntries();
    return InputFormMethod_put_instance;
  }
  function InputFormMethod_delete_getInstance() {
    InputFormMethod_initEntries();
    return InputFormMethod_delete_instance;
  }
  function InputFormMethod_patch_getInstance() {
    InputFormMethod_initEntries();
    return InputFormMethod_patch_instance;
  }
  function InputType_button_getInstance() {
    InputType_initEntries();
    return InputType_button_instance;
  }
  function InputType_checkBox_getInstance() {
    InputType_initEntries();
    return InputType_checkBox_instance;
  }
  function InputType_color_getInstance() {
    InputType_initEntries();
    return InputType_color_instance;
  }
  function InputType_date_getInstance() {
    InputType_initEntries();
    return InputType_date_instance;
  }
  function InputType_dateTime_getInstance() {
    InputType_initEntries();
    return InputType_dateTime_instance;
  }
  function InputType_dateTimeLocal_getInstance() {
    InputType_initEntries();
    return InputType_dateTimeLocal_instance;
  }
  function InputType_email_getInstance() {
    InputType_initEntries();
    return InputType_email_instance;
  }
  function InputType_file_getInstance() {
    InputType_initEntries();
    return InputType_file_instance;
  }
  function InputType_hidden_getInstance() {
    InputType_initEntries();
    return InputType_hidden_instance;
  }
  function InputType_image_getInstance() {
    InputType_initEntries();
    return InputType_image_instance;
  }
  function InputType_month_getInstance() {
    InputType_initEntries();
    return InputType_month_instance;
  }
  function InputType_number_getInstance() {
    InputType_initEntries();
    return InputType_number_instance;
  }
  function InputType_password_getInstance() {
    InputType_initEntries();
    return InputType_password_instance;
  }
  function InputType_radio_getInstance() {
    InputType_initEntries();
    return InputType_radio_instance;
  }
  function InputType_range_getInstance() {
    InputType_initEntries();
    return InputType_range_instance;
  }
  function InputType_reset_getInstance() {
    InputType_initEntries();
    return InputType_reset_instance;
  }
  function InputType_search_getInstance() {
    InputType_initEntries();
    return InputType_search_instance;
  }
  function InputType_submit_getInstance() {
    InputType_initEntries();
    return InputType_submit_instance;
  }
  function InputType_text_getInstance() {
    InputType_initEntries();
    return InputType_text_instance;
  }
  function InputType_tel_getInstance() {
    InputType_initEntries();
    return InputType_tel_instance;
  }
  function InputType_time_getInstance() {
    InputType_initEntries();
    return InputType_time_instance;
  }
  function InputType_url_getInstance() {
    InputType_initEntries();
    return InputType_url_instance;
  }
  function InputType_week_getInstance() {
    InputType_initEntries();
    return InputType_week_instance;
  }
  function KeyGenKeyType_rsa_getInstance() {
    KeyGenKeyType_initEntries();
    return KeyGenKeyType_rsa_instance;
  }
  function RunAt_server_getInstance() {
    RunAt_initEntries();
    return RunAt_server_instance;
  }
  function ScriptCrossorigin_anonymous_getInstance() {
    ScriptCrossorigin_initEntries();
    return ScriptCrossorigin_anonymous_instance;
  }
  function ScriptCrossorigin_useCredentials_getInstance() {
    ScriptCrossorigin_initEntries();
    return ScriptCrossorigin_useCredentials_instance;
  }
  function TextAreaWrap_hard_getInstance() {
    TextAreaWrap_initEntries();
    return TextAreaWrap_hard_instance;
  }
  function TextAreaWrap_soft_getInstance() {
    TextAreaWrap_initEntries();
    return TextAreaWrap_soft_instance;
  }
  function ThScope_col_getInstance() {
    ThScope_initEntries();
    return ThScope_col_instance;
  }
  function ThScope_colGroup_getInstance() {
    ThScope_initEntries();
    return ThScope_colGroup_instance;
  }
  function ThScope_row_getInstance() {
    ThScope_initEntries();
    return ThScope_row_instance;
  }
  function ThScope_rowGroup_getInstance() {
    ThScope_initEntries();
    return ThScope_rowGroup_instance;
  }
  function AreaShape_rect_getInstance() {
    AreaShape_initEntries();
    return AreaShape_rect_instance;
  }
  function AreaShape_circle_getInstance() {
    AreaShape_initEntries();
    return AreaShape_circle_instance;
  }
  function AreaShape_poly_getInstance() {
    AreaShape_initEntries();
    return AreaShape_poly_instance;
  }
  function AreaShape_default_getInstance() {
    AreaShape_initEntries();
    return AreaShape_default_instance;
  }
  var properties_initialized_gen_enums_kt_cpcrt1;
  function _init_properties_gen_enums_kt__jr8w3n() {
    if (!properties_initialized_gen_enums_kt_cpcrt1) {
      properties_initialized_gen_enums_kt_cpcrt1 = true;
      // Inline function 'kotlin.collections.associateBy' call
      var this_0 = values_3();
      var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
      // Inline function 'kotlin.collections.associateByTo' call
      var destination = LinkedHashMap_init_$Create$_1(capacity);
      var inductionVariable = 0;
      var last = this_0.length;
      while (inductionVariable < last) {
        var element = this_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlinx.html.dirValues.<anonymous>' call
        var tmp$ret$0 = element.i2k_1;
        destination.b2(tmp$ret$0, element);
      }
      dirValues = destination;
      // Inline function 'kotlin.collections.associateBy' call
      var this_1 = values_4();
      var capacity_0 = coerceAtLeast(mapCapacity(this_1.length), 16);
      // Inline function 'kotlin.collections.associateByTo' call
      var destination_0 = LinkedHashMap_init_$Create$_1(capacity_0);
      var inductionVariable_0 = 0;
      var last_0 = this_1.length;
      while (inductionVariable_0 < last_0) {
        var element_0 = this_1[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'kotlinx.html.draggableValues.<anonymous>' call
        var tmp$ret$0_0 = element_0.l2k_1;
        destination_0.b2(tmp$ret$0_0, element_0);
      }
      draggableValues = destination_0;
      // Inline function 'kotlin.collections.associateBy' call
      var this_2 = values_13();
      var capacity_1 = coerceAtLeast(mapCapacity(this_2.length), 16);
      // Inline function 'kotlin.collections.associateByTo' call
      var destination_1 = LinkedHashMap_init_$Create$_1(capacity_1);
      var inductionVariable_1 = 0;
      var last_1 = this_2.length;
      while (inductionVariable_1 < last_1) {
        var element_1 = this_2[inductionVariable_1];
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        // Inline function 'kotlinx.html.runAtValues.<anonymous>' call
        var tmp$ret$0_1 = element_1.m2l_1;
        destination_1.b2(tmp$ret$0_1, element_1);
      }
      runAtValues = destination_1;
      // Inline function 'kotlin.collections.associateBy' call
      var this_3 = values_17();
      var capacity_2 = coerceAtLeast(mapCapacity(this_3.length), 16);
      // Inline function 'kotlin.collections.associateByTo' call
      var destination_2 = LinkedHashMap_init_$Create$_1(capacity_2);
      var inductionVariable_2 = 0;
      var last_2 = this_3.length;
      while (inductionVariable_2 < last_2) {
        var element_2 = this_3[inductionVariable_2];
        inductionVariable_2 = inductionVariable_2 + 1 | 0;
        // Inline function 'kotlinx.html.areaShapeValues.<anonymous>' call
        var tmp$ret$0_2 = element_2.y2l_1;
        destination_2.b2(tmp$ret$0_2, element_2);
      }
      areaShapeValues = destination_2;
      // Inline function 'kotlin.collections.associateBy' call
      var this_4 = values();
      var capacity_3 = coerceAtLeast(mapCapacity(this_4.length), 16);
      // Inline function 'kotlin.collections.associateByTo' call
      var destination_3 = LinkedHashMap_init_$Create$_1(capacity_3);
      var inductionVariable_3 = 0;
      var last_3 = this_4.length;
      while (inductionVariable_3 < last_3) {
        var element_3 = this_4[inductionVariable_3];
        inductionVariable_3 = inductionVariable_3 + 1 | 0;
        // Inline function 'kotlinx.html.buttonFormEncTypeValues.<anonymous>' call
        var tmp$ret$0_3 = element_3.w2j_1;
        destination_3.b2(tmp$ret$0_3, element_3);
      }
      buttonFormEncTypeValues = destination_3;
      // Inline function 'kotlin.collections.associateBy' call
      var this_5 = values_0();
      var capacity_4 = coerceAtLeast(mapCapacity(this_5.length), 16);
      // Inline function 'kotlin.collections.associateByTo' call
      var destination_4 = LinkedHashMap_init_$Create$_1(capacity_4);
      var inductionVariable_4 = 0;
      var last_4 = this_5.length;
      while (inductionVariable_4 < last_4) {
        var element_4 = this_5[inductionVariable_4];
        inductionVariable_4 = inductionVariable_4 + 1 | 0;
        // Inline function 'kotlinx.html.buttonFormMethodValues.<anonymous>' call
        var tmp$ret$0_4 = element_4.z2j_1;
        destination_4.b2(tmp$ret$0_4, element_4);
      }
      buttonFormMethodValues = destination_4;
      // Inline function 'kotlin.collections.associateBy' call
      var this_6 = values_1();
      var capacity_5 = coerceAtLeast(mapCapacity(this_6.length), 16);
      // Inline function 'kotlin.collections.associateByTo' call
      var destination_5 = LinkedHashMap_init_$Create$_1(capacity_5);
      var inductionVariable_5 = 0;
      var last_5 = this_6.length;
      while (inductionVariable_5 < last_5) {
        var element_5 = this_6[inductionVariable_5];
        inductionVariable_5 = inductionVariable_5 + 1 | 0;
        // Inline function 'kotlinx.html.buttonTypeValues.<anonymous>' call
        var tmp$ret$0_5 = element_5.c2k_1;
        destination_5.b2(tmp$ret$0_5, element_5);
      }
      buttonTypeValues = destination_5;
      // Inline function 'kotlin.collections.associateBy' call
      var this_7 = values_2();
      var capacity_6 = coerceAtLeast(mapCapacity(this_7.length), 16);
      // Inline function 'kotlin.collections.associateByTo' call
      var destination_6 = LinkedHashMap_init_$Create$_1(capacity_6);
      var inductionVariable_6 = 0;
      var last_6 = this_7.length;
      while (inductionVariable_6 < last_6) {
        var element_6 = this_7[inductionVariable_6];
        inductionVariable_6 = inductionVariable_6 + 1 | 0;
        // Inline function 'kotlinx.html.commandTypeValues.<anonymous>' call
        var tmp$ret$0_6 = element_6.f2k_1;
        destination_6.b2(tmp$ret$0_6, element_6);
      }
      commandTypeValues = destination_6;
      // Inline function 'kotlin.collections.associateBy' call
      var this_8 = values_5();
      var capacity_7 = coerceAtLeast(mapCapacity(this_8.length), 16);
      // Inline function 'kotlin.collections.associateByTo' call
      var destination_7 = LinkedHashMap_init_$Create$_1(capacity_7);
      var inductionVariable_7 = 0;
      var last_7 = this_8.length;
      while (inductionVariable_7 < last_7) {
        var element_7 = this_8[inductionVariable_7];
        inductionVariable_7 = inductionVariable_7 + 1 | 0;
        // Inline function 'kotlinx.html.formEncTypeValues.<anonymous>' call
        var tmp$ret$0_7 = element_7.o2k_1;
        destination_7.b2(tmp$ret$0_7, element_7);
      }
      formEncTypeValues = destination_7;
      // Inline function 'kotlin.collections.associateBy' call
      var this_9 = values_6();
      var capacity_8 = coerceAtLeast(mapCapacity(this_9.length), 16);
      // Inline function 'kotlin.collections.associateByTo' call
      var destination_8 = LinkedHashMap_init_$Create$_1(capacity_8);
      var inductionVariable_8 = 0;
      var last_8 = this_9.length;
      while (inductionVariable_8 < last_8) {
        var element_8 = this_9[inductionVariable_8];
        inductionVariable_8 = inductionVariable_8 + 1 | 0;
        // Inline function 'kotlinx.html.formMethodValues.<anonymous>' call
        var tmp$ret$0_8 = element_8.r2k_1;
        destination_8.b2(tmp$ret$0_8, element_8);
      }
      formMethodValues = destination_8;
      // Inline function 'kotlin.collections.associateBy' call
      var this_10 = values_7();
      var capacity_9 = coerceAtLeast(mapCapacity(this_10.length), 16);
      // Inline function 'kotlin.collections.associateByTo' call
      var destination_9 = LinkedHashMap_init_$Create$_1(capacity_9);
      var inductionVariable_9 = 0;
      var last_9 = this_10.length;
      while (inductionVariable_9 < last_9) {
        var element_9 = this_10[inductionVariable_9];
        inductionVariable_9 = inductionVariable_9 + 1 | 0;
        // Inline function 'kotlinx.html.iframeSandboxValues.<anonymous>' call
        var tmp$ret$0_9 = element_9.u2k_1;
        destination_9.b2(tmp$ret$0_9, element_9);
      }
      iframeSandboxValues = destination_9;
      // Inline function 'kotlin.collections.associateBy' call
      var this_11 = values_8();
      var capacity_10 = coerceAtLeast(mapCapacity(this_11.length), 16);
      // Inline function 'kotlin.collections.associateByTo' call
      var destination_10 = LinkedHashMap_init_$Create$_1(capacity_10);
      var inductionVariable_10 = 0;
      var last_10 = this_11.length;
      while (inductionVariable_10 < last_10) {
        var element_10 = this_11[inductionVariable_10];
        inductionVariable_10 = inductionVariable_10 + 1 | 0;
        // Inline function 'kotlinx.html.imgLoadingValues.<anonymous>' call
        var tmp$ret$0_10 = element_10.x2k_1;
        destination_10.b2(tmp$ret$0_10, element_10);
      }
      imgLoadingValues = destination_10;
      // Inline function 'kotlin.collections.associateBy' call
      var this_12 = values_11();
      var capacity_11 = coerceAtLeast(mapCapacity(this_12.length), 16);
      // Inline function 'kotlin.collections.associateByTo' call
      var destination_11 = LinkedHashMap_init_$Create$_1(capacity_11);
      var inductionVariable_11 = 0;
      var last_11 = this_12.length;
      while (inductionVariable_11 < last_11) {
        var element_11 = this_12[inductionVariable_11];
        inductionVariable_11 = inductionVariable_11 + 1 | 0;
        // Inline function 'kotlinx.html.inputTypeValues.<anonymous>' call
        var tmp$ret$0_11 = element_11.g2l_1;
        destination_11.b2(tmp$ret$0_11, element_11);
      }
      inputTypeValues = destination_11;
      // Inline function 'kotlin.collections.associateBy' call
      var this_13 = values_9();
      var capacity_12 = coerceAtLeast(mapCapacity(this_13.length), 16);
      // Inline function 'kotlin.collections.associateByTo' call
      var destination_12 = LinkedHashMap_init_$Create$_1(capacity_12);
      var inductionVariable_12 = 0;
      var last_12 = this_13.length;
      while (inductionVariable_12 < last_12) {
        var element_12 = this_13[inductionVariable_12];
        inductionVariable_12 = inductionVariable_12 + 1 | 0;
        // Inline function 'kotlinx.html.inputFormEncTypeValues.<anonymous>' call
        var tmp$ret$0_12 = element_12.a2l_1;
        destination_12.b2(tmp$ret$0_12, element_12);
      }
      inputFormEncTypeValues = destination_12;
      // Inline function 'kotlin.collections.associateBy' call
      var this_14 = values_10();
      var capacity_13 = coerceAtLeast(mapCapacity(this_14.length), 16);
      // Inline function 'kotlin.collections.associateByTo' call
      var destination_13 = LinkedHashMap_init_$Create$_1(capacity_13);
      var inductionVariable_13 = 0;
      var last_13 = this_14.length;
      while (inductionVariable_13 < last_13) {
        var element_13 = this_14[inductionVariable_13];
        inductionVariable_13 = inductionVariable_13 + 1 | 0;
        // Inline function 'kotlinx.html.inputFormMethodValues.<anonymous>' call
        var tmp$ret$0_13 = element_13.d2l_1;
        destination_13.b2(tmp$ret$0_13, element_13);
      }
      inputFormMethodValues = destination_13;
      // Inline function 'kotlin.collections.associateBy' call
      var this_15 = values_12();
      var capacity_14 = coerceAtLeast(mapCapacity(this_15.length), 16);
      // Inline function 'kotlin.collections.associateByTo' call
      var destination_14 = LinkedHashMap_init_$Create$_1(capacity_14);
      var inductionVariable_14 = 0;
      var last_14 = this_15.length;
      while (inductionVariable_14 < last_14) {
        var element_14 = this_15[inductionVariable_14];
        inductionVariable_14 = inductionVariable_14 + 1 | 0;
        // Inline function 'kotlinx.html.keyGenKeyTypeValues.<anonymous>' call
        var tmp$ret$0_14 = element_14.j2l_1;
        destination_14.b2(tmp$ret$0_14, element_14);
      }
      keyGenKeyTypeValues = destination_14;
      // Inline function 'kotlin.collections.associateBy' call
      var this_16 = values_14();
      var capacity_15 = coerceAtLeast(mapCapacity(this_16.length), 16);
      // Inline function 'kotlin.collections.associateByTo' call
      var destination_15 = LinkedHashMap_init_$Create$_1(capacity_15);
      var inductionVariable_15 = 0;
      var last_15 = this_16.length;
      while (inductionVariable_15 < last_15) {
        var element_15 = this_16[inductionVariable_15];
        inductionVariable_15 = inductionVariable_15 + 1 | 0;
        // Inline function 'kotlinx.html.scriptCrossoriginValues.<anonymous>' call
        var tmp$ret$0_15 = element_15.p2l_1;
        destination_15.b2(tmp$ret$0_15, element_15);
      }
      scriptCrossoriginValues = destination_15;
      // Inline function 'kotlin.collections.associateBy' call
      var this_17 = values_15();
      var capacity_16 = coerceAtLeast(mapCapacity(this_17.length), 16);
      // Inline function 'kotlin.collections.associateByTo' call
      var destination_16 = LinkedHashMap_init_$Create$_1(capacity_16);
      var inductionVariable_16 = 0;
      var last_16 = this_17.length;
      while (inductionVariable_16 < last_16) {
        var element_16 = this_17[inductionVariable_16];
        inductionVariable_16 = inductionVariable_16 + 1 | 0;
        // Inline function 'kotlinx.html.textAreaWrapValues.<anonymous>' call
        var tmp$ret$0_16 = element_16.s2l_1;
        destination_16.b2(tmp$ret$0_16, element_16);
      }
      textAreaWrapValues = destination_16;
      // Inline function 'kotlin.collections.associateBy' call
      var this_18 = values_16();
      var capacity_17 = coerceAtLeast(mapCapacity(this_18.length), 16);
      // Inline function 'kotlin.collections.associateByTo' call
      var destination_17 = LinkedHashMap_init_$Create$_1(capacity_17);
      var inductionVariable_17 = 0;
      var last_17 = this_18.length;
      while (inductionVariable_17 < last_17) {
        var element_17 = this_18[inductionVariable_17];
        inductionVariable_17 = inductionVariable_17 + 1 | 0;
        // Inline function 'kotlinx.html.thScopeValues.<anonymous>' call
        var tmp$ret$0_17 = element_17.v2l_1;
        destination_17.b2(tmp$ret$0_17, element_17);
      }
      thScopeValues = destination_17;
    }
  }
  function A(initialAttributes, consumer) {
    HTMLTag.call(this, 'a', consumer, initialAttributes, null, true, false);
    this.f2m_1 = consumer;
  }
  protoOf(A).n2i = function () {
    return this.f2m_1;
  };
  function BUTTON(initialAttributes, consumer) {
    HTMLTag.call(this, 'button', consumer, initialAttributes, null, true, false);
    this.s2m_1 = consumer;
  }
  protoOf(BUTTON).n2i = function () {
    return this.s2m_1;
  };
  function DIV(initialAttributes, consumer) {
    HTMLTag.call(this, 'div', consumer, initialAttributes, null, false, false);
    this.z2m_1 = consumer;
  }
  protoOf(DIV).n2i = function () {
    return this.z2m_1;
  };
  function SCRIPT(initialAttributes, consumer) {
    HTMLTag.call(this, 'script', consumer, initialAttributes, null, false, false);
    this.g2n_1 = consumer;
  }
  protoOf(SCRIPT).n2i = function () {
    return this.g2n_1;
  };
  function HTMLTag$attributes$lambda(this$0) {
    return function () {
      return this$0.n2i();
    };
  }
  function HTMLTag(tagName, consumer, initialAttributes, namespace, inlineTag, emptyTag) {
    namespace = namespace === VOID ? null : namespace;
    this.g2m_1 = tagName;
    this.h2m_1 = consumer;
    this.i2m_1 = namespace;
    this.j2m_1 = inlineTag;
    this.k2m_1 = emptyTag;
    var tmp = this;
    tmp.l2m_1 = new DelegatingMap(initialAttributes, this, HTMLTag$attributes$lambda(this));
  }
  protoOf(HTMLTag).m2i = function () {
    return this.g2m_1;
  };
  protoOf(HTMLTag).n2i = function () {
    return this.h2m_1;
  };
  protoOf(HTMLTag).o2i = function () {
    return this.i2m_1;
  };
  protoOf(HTMLTag).p2i = function () {
    return this.l2m_1;
  };
  protoOf(HTMLTag).q2i = function () {
    return this.p2i().t2j();
  };
  function get_create(_this__u8e3s4) {
    return new JSDOMBuilder(_this__u8e3s4);
  }
  function asR(_this__u8e3s4, $this) {
    // Inline function 'kotlin.js.asDynamic' call
    return _this__u8e3s4;
  }
  function JSDOMBuilder(document) {
    this.h2n_1 = document;
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.i2n_1 = ArrayList_init_$Create$();
    this.j2n_1 = null;
  }
  protoOf(JSDOMBuilder).k2n = function (tag) {
    var tmp;
    if (!(tag.o2i() == null)) {
      // Inline function 'kotlin.js.asDynamic' call
      tmp = this.h2n_1.createElementNS(ensureNotNull(tag.o2i()), tag.m2i());
    } else {
      var tmp_0 = this.h2n_1.createElement(tag.m2i());
      tmp = tmp_0 instanceof HTMLElement ? tmp_0 : THROW_CCE();
    }
    var element = tmp;
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = tag.q2i().g();
    while (tmp0_iterator.h()) {
      var element_0 = tmp0_iterator.i();
      // Inline function 'kotlinx.html.dom.JSDOMBuilder.onTagStart.<anonymous>' call
      element.setAttribute(element_0.u(), element_0.v());
    }
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this.i2n_1.o()) {
      last(this.i2n_1).appendChild(element);
    }
    this.i2n_1.e(element);
  };
  protoOf(JSDOMBuilder).q2j = function (tag, attribute, value) {
    if (this.i2n_1.o())
      throw IllegalStateException_init_$Create$('No current tag');
    else {
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp = last(this.i2n_1).tagName.toLowerCase();
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      if (!(tmp === tag.m2i().toLowerCase()))
        throw IllegalStateException_init_$Create$('Wrong current tag');
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var node = last(this.i2n_1);
        if (value == null) {
          node.removeAttribute(attribute);
        } else {
          node.setAttribute(attribute, value);
        }
      }
    }
  };
  protoOf(JSDOMBuilder).l2n = function (tag, event, value) {
    if (this.i2n_1.o())
      throw IllegalStateException_init_$Create$('No current tag');
    else {
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp = last(this.i2n_1).tagName.toLowerCase();
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      if (!(tmp === tag.m2i().toLowerCase()))
        throw IllegalStateException_init_$Create$('Wrong current tag');
      else {
        // Inline function 'kotlin.js.asDynamic' call
        last(this.i2n_1)[event] = value;
      }
    }
  };
  protoOf(JSDOMBuilder).m2n = function (tag) {
    var tmp;
    if (this.i2n_1.o()) {
      tmp = true;
    } else {
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp_0 = last(this.i2n_1).tagName.toLowerCase();
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = !(tmp_0 === tag.m2i().toLowerCase());
    }
    if (tmp) {
      throw IllegalStateException_init_$Create$("We haven't entered tag " + tag.m2i() + ' but trying to leave');
    }
    this.j2n_1 = this.i2n_1.v1(get_lastIndex(this.i2n_1));
  };
  protoOf(JSDOMBuilder).s2i = function (content) {
    if (this.i2n_1.o()) {
      throw IllegalStateException_init_$Create$('No current DOM node');
    }
    last(this.i2n_1).appendChild(this.h2n_1.createTextNode(toString(content)));
  };
  protoOf(JSDOMBuilder).n2n = function () {
    var tmp0_safe_receiver = this.j2n_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : asR(tmp0_safe_receiver, this);
    var tmp;
    if (tmp1_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$("We can't finalize as there was no tags");
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  };
  function set_onClickFunction(_this__u8e3s4, newValue) {
    _this__u8e3s4.n2i().l2n(_this__u8e3s4, 'onclick', newValue);
  }
  //region block: post-declaration
  protoOf(HTMLTag).r2i = text;
  //endregion
  //region block: init
  StringEncoder_instance = new StringEncoder();
  StringSetEncoder_instance = new StringSetEncoder();
  TickerEncoder_instance = new TickerEncoder();
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = enumEncode;
  _.$_$.b = get_create;
  _.$_$.c = set_onClickFunction;
  _.$_$.d = A;
  _.$_$.e = BUTTON;
  _.$_$.f = DIV;
  _.$_$.g = SCRIPT;
  _.$_$.h = attributesMapOf_0;
  _.$_$.i = attributesMapOf;
  _.$_$.j = set_classes;
  //endregion
  return _;
}));
